export default {
  name: 'MobileHeader',
  data: function data() {
    return {
      visible: false
    };
  },
  methods: {
    triggerSearch: function triggerSearch() {
      this.visible = true;
      this.$emit('searchQuery', this.visible);
    }
  }
};